export default [{
  src: '/img/games/sbobet.png',
  code: 'sbo',
  label: 'SBO',
  route: '/sbo?GameType=VirtualSports',
  id: 14
}]